var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.121,
    height: 8.428,
    viewBox: "0 0 8.121 8.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_17894",
    "data-name": "Group 17894",
    transform: "translate(-874.44 -835.132)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x1: 6,
    y2: 6.308,
    transform: "translate(875.5 836.192)",
    fill: "none",
    stroke: "#c5c5c5",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x2: 6,
    y2: 6.308,
    transform: "translate(875.5 836.192)",
    fill: "none",
    stroke: "#c5c5c5",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcn);
export default __webpack_public_path__ + "static/media/close-icn.d0afb1be8b9a6597eb984934e89127f2.svg";
export { ForwardRef as ReactComponent };